import clsx from "clsx";
import { MaxWidthWrapper, WidthLimiterLayoutRoot } from "./WidthLimiterLayout.styles";

export interface WidthLimiterLayoutProps {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

function WidthLimiterLayout({ className, children, ...rest }: WidthLimiterLayoutProps) {
    return (
        <WidthLimiterLayoutRoot className={clsx("width-limiter-layout", className)} alignItems="center" justifyContent="center" {...rest}>
            <MaxWidthWrapper flex={1}>{children}</MaxWidthWrapper>
        </WidthLimiterLayoutRoot>
    );
}

export default WidthLimiterLayout;
